module.exports = __webpack_public_path__ + "media/img/pages/companies/ckw-05b7e2b3b06fe5b306912a38171376ff.png";